import React from 'react';
import LibModalNavTip from '../layouts/LibModalNavTip';

function Tip() {
  return (
    <LibModalNavTip>
      <p>可以通过“3D模型互动工具”创建3D模型作品</p>
    </LibModalNavTip>
  );
}

export default Tip;
